import moment from 'moment';
import { store } from 'redux/store';
import _ from 'lodash';

const assignedAndSyncedWorkOrderManipulationJson = async ({
  workOrderCache,
  syncWorkOrderCache,
  initialLogin
}) => {
  const { tasks } = store.getState();

  const allWOTasksMap =
    tasks?.tasksList?.length > 0 && !initialLogin
      ? tasks.tasksList.reduce((acc, task) => {
          acc[task.workorderId] = true;
          return acc;
        }, {})
      : {};

  // await cacheWorkOrderPhotosAndDocuments({ workOrderCache });

  const workOrdersAll = [
    ...(syncWorkOrderCache?.map((wo) => ({
      ...wo,
      status: 'Synced',
      statusId: wo.status,
      type: wo.entityType === 'WorkRequest' ? 'Work Request' : 'Work Order',
      id: wo.workOrderNumber
    })) || []),

    ...(workOrderCache?.map((wo) => ({
      ...wo,
      status: 'To do',
      statusId: wo.status,
      type: 'Work Order',
      id: wo.workOrderNumber
    })) || [])
  ];

  let newSyncedTask = [];
  if (!_.isEmpty(allWOTasksMap)) {
    newSyncedTask = workOrdersAll.map((task) => {
      if (!allWOTasksMap[task.workorderId]) {
        return {
          syncDateCustom: moment().format('YYYY-MM-DD'),
          ...task
        };
      } else return task;
    });
  } else newSyncedTask = workOrdersAll;

  const recurringTemplatesMap = {};

  const tasksList = (newSyncedTask || []).map((task) => {
    const { rtId, rtName, rtNumber, workOrderNumber } = task;
    if (rtId && !recurringTemplatesMap[rtId]) {
      const allWorkOrder = (newSyncedTask || []).filter((x) => x.rtId === rtId) || [];
      const allDoneTasks = allWorkOrder.filter((task) => task?.status === 'Synced') || [];
      const allotDoneTasks = allWorkOrder.filter((task) => task?.status !== 'Synced') || [];

      const today = moment().format('YYYY-MM-DD');
      const isOverDue = allotDoneTasks.find((task) =>
        task.dueDate ? moment(task.dueDate).isBefore(today) : false
      );

      recurringTemplatesMap[rtId] = {
        rtId,
        title: rtName,
        id: rtNumber,
        allWorkOrder: _.size(allWorkOrder),
        allDoneTasks: _.size(allDoneTasks),
        allotDoneTasks: _.size(allDoneTasks),
        isOverDue: isOverDue
      };
    }

    return {
      ...task,
      type: task?.entityType === 'WorkRequest' ? 'Work Request' : 'Work Order',
      id: workOrderNumber || ''
    };
  });

  let tasksAll = [
    ...tasks.tasksList.filter((t) => t.status === 'Pending sync' || t.status === 'In progress')
  ];

  tasksList.map((task) => {
    const found = tasksAll.findIndex((t) => t.workorderId === task.workorderId) + 1;
    if (found) {
      if (!['In progress', 'Pending sync'].includes(tasksAll[found - 1].status)) {
        tasksAll[found - 1] = { ...task };
      }
    } else {
      tasksAll.push({ ...task });
    }
  });

  let map = {};

  for (let i = 0; i < tasksAll.length; i++) {
    const obj = tasksAll[i];

    const id = obj.workorderId || obj.woId;
    map[id] = obj;
  }

  return {
    workOrdersMap: { ...map },
    tasksList: [...tasksAll],
    recurringTemplatesMap: recurringTemplatesMap
  };
};

const cacheWorkOrderPhotosAndDocuments = async ({ workOrderCache }) => {
  try {
    caches.delete('task-images');
    const { settings } = store.getState();
    if (navigator.onLine && settings?.settings?.autoConnectWOPhoto !== 'never') {
      let connection = 'wifi';

      if ('connection' in navigator) {
        connection = navigator.connection.type || 'wifi';
      }
      if (
        (settings?.settings?.autoConnectWOPhoto === 'wifi' && connection !== 'cellular') ||
        settings?.settings?.autoConnectWOPhoto === 'any'
      ) {
        console.log('Work Order Images Caching start');

        let images = [];
        workOrderCache?.map((data) => data?.photos?.map((p) => images.push(p?.url)));
        await Promise.all(images.map((link) => fetch(link)));
      }
    }
  } catch (err) {
    console.log('Work Order Images Caching failed');
  }

  try {
    const { settings } = store.getState();
    caches.delete('documents');
    if (navigator.onLine && settings?.settings?.autoConnectWODocument !== 'never') {
      let connection = 'wifi';

      if ('connection' in navigator) {
        connection = navigator.connection.type || 'wifi';
      }

      if (
        (settings?.settings?.autoConnectWODocument === 'wifi' && connection !== 'cellular') ||
        settings?.settings?.autoConnectWODocument === 'any'
      ) {
        console.log('Work Order Documents Caching start');

        let documents = [];
        workOrderCache?.map((data) => data?.documents?.map((p) => documents.push(p?.url)));
        await Promise.all(documents.map((link) => fetch(link)));
      }
    }
  } catch (err) {
    console.log('Work Order Documents Caching failed');
  }
};
export { assignedAndSyncedWorkOrderManipulationJson, cacheWorkOrderPhotosAndDocuments };
